module.exports = __webpack_public_path__ + "static/media/16-20.3b53d556.png";